export default "__VITE_ASSET__c782f6ee__"